import ReactDOM from "react-dom";
import { ImDice } from "react-icons/im";
import DateRangePicker from "./DateRangePicker";
import OutsideClickHandler from "react-outside-click-handler";
const GameRecordFilter = ({ type, setFilter, setShow, filter, page }) => {
  let object = {
    vendor: History,
    depositMethod: DepositStatus,
    depositType: DepositType,
    WithdrawType: WithdrawType,
  };
  return ReactDOM.createPortal(
    <div data-reactroot>
      <div className="am-popup-mask" />
      <div
        tabIndex={-1}
        className={
          type == "range"
            ? "am-popup-wrap EN new-date-picker bet15bdtf6"
            : "am-popup-wrap mc-daterange-popup"
        }
        role="dialog"
      >
        <OutsideClickHandler
          onOutsideClick={() => {
            setShow({
              type: "",
              status: false,
            });
          }}
        >
          <div role="document" className="am-popup am-popup-slide-up">
            <div className="am-popup-content">
              <button aria-label="Close" className="am-popup-close">
                <span className="am-popup-close-x" />
              </button>
              <div className="am-popup-body">
                {type == "range" && (
                  <DateRangePicker
                    fromPeriod={filter?.fromPeriod}
                    toPeriod={filter?.toPeriod}
                    onApply={(start, end) => {
                      setFilter((prev) => {
                        return {
                          ...prev,
                          fromPeriod: start.format("YYYY-MM-DD HH:mm:ss"),
                          toPeriod: end.format("YYYY-MM-DD HH:mm:ss"),
                        };
                      });
                    }}
                    setShow={setShow}
                  />
                )}
                {[
                  "vendor",
                  "depositMethod",
                  "depositType",
                  "WithdrawType",
                ].includes(type) && (
                  <div className="mc-popup-txtype">
                    <div className="am-list">
                      <div className="am-list-header">
                        <div style={{ position: "relative" }}>
                          {type == "vendor"
                            ? "Vendors"
                            : type == "depositMethod"
                            ? "Please choose the deposit method"
                            : type == "depositType"
                            ? "Types"
                            : "Status"}
                          <span
                            onClick={() => {
                              setShow({
                                type: "",
                                status: false,
                              });
                            }}
                            style={{
                              position: "absolute",
                              right: "3px",
                              top: "-5px",
                            }}
                          >
                            <svg className="am-icon am-icon-cross am-icon-md">
                              <use xlinkHref="#cross" />
                            </svg>
                          </span>
                        </div>
                      </div>

                      <div className="am-list-body">
                        {[
                          "depositMethod",
                          "vendor",
                          "depositType",
                          "WithdrawType",
                        ].includes(type) && (
                          <>
                            {object[type]?.map((res) => {
                              return (
                                <div
                                  onClick={() => {
                                    setFilter((prev) => {
                                      return type == "depositType"
                                        ? { ...prev, status: res }
                                        : {
                                            ...prev,
                                            [page == "history"
                                              ? "betType"
                                              : "type"]: res,
                                          };
                                    });
                                    setShow({
                                      type: "",
                                      status: false,
                                    });
                                  }}
                                  className="am-list-item am-list-item-middle"
                                >
                                  <div className="am-list-line">
                                    <div className="am-list-content">
                                      <ImDice
                                        color="#888"
                                        className="am-icon am-icon-dice_02706417 am-icon-md svg-icon-dice"
                                      />
                                      {res}
                                    </div>
                                  </div>
                                </div>
                              );
                            })}{" "}
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
            <div
              tabIndex={0}
              style={{ width: "0px", height: "0px", overflow: "hidden" }}
            >
              sentinel
            </div>
          </div>
        </OutsideClickHandler>
      </div>
    </div>,
    document.getElementById("overlay")
  );
};

export default GameRecordFilter;

let History = ["BetFair", "Bookmaker", "Fancy", "SportsBook"];
// let History = [
//   "All",
//   "Jili",
//   "PG",
//   "Spribe",
//   "FC",
//   "JDB",
//   "PP",
//   "BTGaming",
//   "BOM",
//   "RT",
//   "MAS",
//   "MG",
//   "NAGA",
//   "Evoplay",
//   "Live22",
//   "Manna play",
//   "SG",
//   "DB SLOTS",
//   "First Person",
//   "BGaming",
//   "Eazy Gaming",
//   "5G",
//   "Gemini",
//   "MA",
//   "YL",
//   "FTG",
//   "PLAYSTAR",
//   "Smartsoft",
//   "YELLOW BAT",
//   "Nextspin",
//   "Amigo Gaming",
//   "MAHA Gaming",
//   "Wazdan",
//   "RLX",
//   "CG",
//   "Octoplay",
//   "Pascal Gaming",
//   "AMBS",
//   "KA",
//   "BNG",
//   "BTG",
//   "AE",
//   "759 Gaming",
//   "Joker",
//   "NetEnt",
//   "Baison Poker",
//   "NLC",
//   "AVATAR UX",
//   "GPI",
//   "Hacksaw",
//   "Fastspin",
//   "Victory Ark",
//   "Triple Profits Games",
//   "Yggdrasil",
// ];

let DepositType = ["All", "Bkash", "NAGAD", "ROCKET"];
let WithdrawType = [
  "All",
  "Processing",
  "Transferring",
  "Withdraw Success",
  "Withdraw Failed",
];
let DepositStatus = [
  "Types",
  "Approved",
  "Cancelled",
  "Pending",
  "New",
  "Reject",
];
let Sports = [
  {
    key: "betfair",
    value: "Exchange",
  },
  {
    key: "bookmaker",
    value: "Bookmaker",
  },
  {
    key: "fancy",
    value: "Fancybet",
  },
  {
    key: "sportsBook",
    value: "Sportsbook",
  },
];
